import shortText from './short_text';
import longText from './long_text';
import singleSelect from './single_select';
import multiSelect from './multi_select';
import fiveStar from './five_star';
import checkbox from './checkbox';
import file from './file';
import location from './location';
import array from './array';

export default {
  'short_text': shortText,
  'long_text': longText,
  'single_select': singleSelect,
  'multi_select': multiSelect,
  'five_star': fiveStar,
  'checkbox': checkbox,
  'file': file,
  'location': location,
  'array': array,
};
